module.exports = __webpack_public_path__ + "img/logo-menu.0742b96b.png";